/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { Box, BoxProps, Card, CardContent, CardHeader, Grid, Typography, TypographyProps } from "@mui/material";
import UIConstants from "../../../UIConstants";
import { translationKeys, useTranslation } from "../../Internationalisierung/i18nBasis";

type ProvisionHinweisProps = {
    variant?: TypographyProps["variant"];
    color?: TypographyProps["color"];
    sx?: BoxProps["sx"];
    hideUstUndZusatzkosten?: Boolean;
}

export default function ProvisionHinweis(props: ProvisionHinweisProps) {
    const { t } = useTranslation();

    const titleTypographyProps = { color: "white", fontSize: "90%" };
    const subheaderTypographyProps = { color: "white", fontSize: "120%" };
    const cardStyle = { height: "100%" };
    const listStyle = { margin: "5px" };

    return (
        <Box sx={props.sx}>
            <Grid container spacing={2} mb={"30px"}>
                <Grid item xs={12} md={6}>
                    <Card sx={cardStyle}>
                        <CardHeader
                            title={t(translationKeys.provisionHinweis.preismodell)}
                            titleTypographyProps={titleTypographyProps}
                            subheader={t(translationKeys.provisionHinweis.gemeinnuetzig)}
                            subheaderTypographyProps={subheaderTypographyProps}
                            style={{ backgroundColor: "#E6007E" }}
                        />
                        <CardContent>
                            <Typography variant="body2" color="text.secondary" fontWeight={"bold"}>
                                {t(translationKeys.provisionHinweis.provisionTextTestzeitraum)}
                            </Typography>
                            <Box component="ul" sx={listStyle}>
                                <Box component="li">
                                    <Typography variant="body2" color="text.secondary">
                                        {t(translationKeys.provisionHinweis.provisionGemeinnuetzig)}
                                    </Typography>
                                </Box>
                                <Box component="li">
                                    <Typography variant="body2" color="text.secondary">
                                        {t(translationKeys.provisionHinweis.provisionMindestens)}
                                    </Typography>
                                </Box>
                            </Box>
                            <Typography variant="body2" color="text.secondary">
                                {t(translationKeys.provisionHinweis.provisionProTeilnahme)}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ margin: "10px 0 0 0" }}>
                                {t(translationKeys.provisionHinweis.minimalerAbrechnungsbetrag)}
                            </Typography>
                            <Typography sx={{ margin: "10px 0 0 0", fontStyle: "italic", fontSize: "85%" }} color={props.color} variant={props.variant}>
                                {t(translationKeys.provisionHinweis.nachweisGemeinnuetzigkeit)} <a href={`mailto:${UIConstants.vertriebEMail}`}>{UIConstants.vertriebEMail}</a>
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Card sx={cardStyle}>
                        <CardHeader
                            title={t(translationKeys.provisionHinweis.preismodell)}
                            titleTypographyProps={titleTypographyProps}
                            subheader={t(translationKeys.provisionHinweis.gewerblich)}
                            subheaderTypographyProps={subheaderTypographyProps}
                            style={{ backgroundColor: "#0D184B" }}
                        />
                        <CardContent>
                            <Typography variant="body2" color="text.secondary" fontWeight={"bold"}>
                                {t(translationKeys.provisionHinweis.provisionTextTestzeitraum)}
                            </Typography>
                            <Box component="ul" sx={listStyle}>
                                <Box component="li">
                                    <Typography variant="body2" color="text.secondary">
                                        {t(translationKeys.provisionHinweis.provisionGewerblich)}
                                    </Typography>
                                </Box>
                                <Box component="li">
                                    <Typography variant="body2" color="text.secondary">
                                        {t(translationKeys.provisionHinweis.provisionMindestens)}
                                    </Typography>
                                </Box>
                            </Box>
                            <Typography variant="body2" color="text.secondary">
                                {t(translationKeys.provisionHinweis.provisionProTeilnahme)}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ margin: "10px 0 0 0" }}>
                                {t(translationKeys.provisionHinweis.minimalerAbrechnungsbetrag)}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            { !props.hideUstUndZusatzkosten &&
                <Typography sx={{ textAlign: "center", fontStyle: "italic", fontSize: "85%", mb: "10px" }}>
                    {t(translationKeys.provisionHinweis.ustUndZusatzkosten)}
                </Typography>
            }
        </Box>
    )
}